import React from "react";

const HamburgerIcon: React.FC<{
  width?: number;
  height?: number;
  color?: string;
}> = ({ width = 18, height = 15, color = "white" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 18 15"
    fill="none"
  >
    <rect y="12" width="12" height="3" rx="1.5" fill={color} />
    <rect y="6" width="18" height="3" rx="1.5" fill={color} />
    <rect width="18" height="3" rx="1.5" fill={color} />
  </svg>
);

export default HamburgerIcon;
